module.exports = __webpack_public_path__ + "img/gpay2.b49f4a68.png";